import styled from 'styled-components';

interface RowProps {
  xs?: string;
  sm?: string;
  md?: string;
  lg?: string;
  xl?: string;
  xxl?: string;
  gap?: string;
}

// Troca tracks "1fr" soltos por "minmax(0, 1fr)": sem isso, uma coluna não
// consegue encolher abaixo do min-content do conteúdo (ex: texto/título longo),
// e a grade estoura a largura da tela em vez de deixar o conteúdo quebrar linha.
const safeTemplate = (template?: string) =>
  template ? template.replace(/\b1fr\b/g, 'minmax(0, 1fr)') : template;

const Row = styled.div<RowProps>`
  display: grid;
  gap: ${(props) => props.gap || '16px'};
  grid-template-columns: ${(props) => safeTemplate(props.xs) || '1fr'};
  max-width: 1440px;
  margin: auto;

  @media (min-width: 576px) {
    grid-template-columns: ${(props) => safeTemplate(props.sm || props.xs) || '1fr'};
  }

  @media (min-width: 768px) {
    grid-template-columns: ${(props) => safeTemplate(props.md || props.sm || props.xs) || '1fr'};
  }

  @media (min-width: 992px) {
    grid-template-columns: ${(props) => safeTemplate(props.lg || props.md || props.sm || props.xs) || '1fr'};
  }

  @media (min-width: 1200px) {
    grid-template-columns: ${(props) => safeTemplate(props.xl || props.lg || props.md || props.sm || props.xs) || '1fr'};
  }

  @media (min-width: 1400px) {
    grid-template-columns: ${(props) => safeTemplate(props.xxl || props.xl || props.lg || props.md || props.sm || props.xs) || '1fr'};
  }
`;

export default Row;
